// de_pms_billing.ts
// Tłumaczenia dla PMS.Billing.tsx

export const dePmsBilling = {

  title:       "Abrechnung",
  description: "Gastfolios, geteilte Abrechnung, Rückerstattungen, Korrekturen, Rechnungen und Fiskalbereitschaft.",

  // ── Sekcje ───────────────────────────────────────────────────────────────
  sections: {
    folioWorkspace:      "Folio-Arbeitsbereich",
    folioActivity:       "Folio-Aktivität",
    postCharges:         "Leistungen buchen",
    refundsAdjustments:  "Rückerstattungen und Korrekturen",
    invoicesFiscal:      "Rechnungen und Fiskalwesen",
    groupBillingSnapshot:"Übersicht der Gruppenabrechnung",
  },

  // ── Opisy sekcji ─────────────────────────────────────────────────────────
  descriptions: {
    chargeWorkflow:  "Leistungsbuchung, Abrechnung, Rechnungsstellung und Korrekturen.",
    currentItems:    "Aktuelle Positionen, Zahlungen und Rückerstattungen für das ausgewählte Folio.",
    controlledReversal:"Kontrollierter Storno- und Korrekturworkflow.",
    partialPayments: "Teil- und Split-Zahlungen über mehrere Zahlungsmethoden.",
    generateInvoice: "Rechnung erstellen und über die Fiskalintegration weiterleiten.",
    groupFolioSummary:"Die Zusammenfassung des Gruppenfolios bleibt verfügbar.",
  },

  // ── Metody płatności ──────────────────────────────────────────────────────
  paymentMethods: {
    card:      "Karte",
    cash:      "Bar",
    noPayment: "Keine Zahlung",
    methodOne: "Zahlungsmethode 1",
    methodTwo: "Zahlungsmethode 2",
  },

  // ── Kategorie opłat ───────────────────────────────────────────────────────
  chargeCategories: {
    minibar:    "Minibar",
    lateCharge: "Nachbelastung",
    other:      "Sonstiges",
  },

  // ── Etykiety ──────────────────────────────────────────────────────────────
  labels: {
    folio:            "Folio",
    invoice:          "Rechnung",
    fiscalizedInvoice:"Fiskalisierte Rechnung",
    chargeCategory:   "Leistungskategorie",
    balanceDue:       "Offener Betrag",
    activeFolio:      "Aktives Folio",
    billingCompany:   "Rechnungsfirma",
    noFolioSelected:  "Kein Folio ausgewählt",
  },

  // ── Komunikaty ────────────────────────────────────────────────────────────
  messages: {
    adjustmentFailed: "Korrektur fehlgeschlagen.",
    chargeFailed:     "Buchung der Leistung fehlgeschlagen.",
    invoiceFailed:    "Rechnungserstellung fehlgeschlagen.",
    refundFailed:     "Rückerstattung fehlgeschlagen.",
  },

} as const;

export default dePmsBilling;
